import { type CardField } from 'components/framework/models';
import DraggableItem from 'javascripts/dnd/DraggableItem';

class DraggableCardField extends DraggableItem<CardField> {
  get field() {
    return this.item.field;
  }

  get cardField() {
    return this.item;
  }
}

export default DraggableCardField;
